import React from 'react';
import { ChartWrapper } from '../../chartWrapper/ChartWrapper';
import { OutgoingCsSkeleton } from '../../skeletons/OutgoingCsSkelenot';

interface Props {
  isLoading: boolean;
}

export const ApcSalesCs: React.FC<Props> = ({ isLoading }): JSX.Element => {
  const attrs = {
    wrapper: {
      isEmptyWrapper: true,
      title: 'APC vs. Sales Cycle',
      subtitle: 'Average, total deals, last 90 days',
    },
    chart: { className: 'apc-sales-chart-graph' },
  };
  return (
    <OutgoingCsSkeleton isLoading={isLoading}>
      <ChartWrapper {...attrs.wrapper}>
        <div {...attrs.chart} />
      </ChartWrapper>
    </OutgoingCsSkeleton>
  );
};
